import React, { useState, useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { Form, FormItem } from "@/components/ui/Form";
import Input from "@/components/ui/Input";
import Button from "@/components/ui/Button";
import { useAuth } from "@/auth";
import { useNavigate } from "react-router-dom";

// Initial reducer state
const initialState = {
  otpSent: false,
  isOtpSending: false,
  disableSubmit: false,
  message: "",
  error: "",
  emailReadOnly: false,
};

type State = typeof initialState;
type Action = Partial<State>;

function reducer(state: State, action: Action): State {
  return { ...state, ...action };
}



const ChangeOtpForm = () => {



  const [state, dispatch] = useReducer(reducer, initialState);
  const { otpSent, isOtpSending, disableSubmit, message, error, emailReadOnly } = state;
  const { signotp } = useAuth();
  const navigate = useNavigate();
  const apiUrl = import.meta.env.VITE_API_URL;
  const token = import.meta.env.VITE_API_URL_TOKEN;

  const [emailNew, setEmailNew] = useState("");

  useEffect(() => {
    const storedUsername = localStorage.getItem("username") || sessionStorage.getItem("NewEmail") || "";
    setEmailNew(storedUsername);





  }, []);

  const [sessionId, setSessionId] = useState(sessionStorage.getItem("sessionId") || "");



  useEffect(() => {
    if (!sessionId) {
      const newSessionId = `session-${Date.now()}-${Math.floor(Math.random() * 100000)}`;
      setSessionId(newSessionId);
      sessionStorage.setItem("sessionId", newSessionId);

      console.log("sessionId", sessionId);

    }
  }, [sessionId]);





  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: { emailId: "", otp: "" },
  });

  const handleEmailSubmit = async (data: { emailId: string }) => {
    dispatch({ error: "", message: "", isOtpSending: true });

    if (!apiUrl || !token) {
      dispatch({ error: "Server configuration error.", isOtpSending: false });
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/forgotpassword/generate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ emailId: emailNew }),
        credentials: "include",
      });

      const result = await response.json();
      if (response.ok) {
        dispatch({
          otpSent: true,
          emailReadOnly: true,
          message: "OTP has been sent to your email address. ",
        });
      } else {
        dispatch({ error: result.message || "Failed to send OTP." });
      }
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "An error occurred. Please try again.";
      dispatch({ error: errorMessage });
    } finally {
      dispatch({ isOtpSending: false });
    }
  };

  const { changepasswordsumbit } = useAuth();


  const onSignotp1 = async (data: { otp: string; emailId: string }) => {
  const otp = getValues('otp');

const email2: string | null = localStorage.getItem("username");

if (email2) {
  sessionStorage.setItem("NewEmail", email2);
}

//const emailId = sessionStorage.getItem("NewEmail")
const emailId: string | null = sessionStorage.getItem("NewEmail");

  // if (!emailId) {
  //   dispatch({
  //     error: "Email not found. Please try again.",
  //     otpSent: false,       // Allow resending OTP
  //     disableSubmit: false,
  //   });
  //   return;
  // }

  try {
   // dispatch({ error: "", message: "", disableSubmit: true });
if (!emailId) {
  throw new Error("Email ID not found in sessionStorage");
}
    const result = await changepasswordsumbit({ emailId, otp });

    if (result?.status === 'failed') {
      dispatch({
        error: result.message || "OTP verification failed. Please try again.",
        disableSubmit: false,
        otpSent: false,      // ✅ Enable Send OTP button again
      });
    } else if (result?.status === 'success') {
      dispatch({
        message: result.message || "OTP verified successfully. Redirecting...",
        error: "",
        disableSubmit: false,
      });

      setTimeout(() => {
        window.location.href = "/portal/change-password";
      }, 1000);
    } else {
      dispatch({
        error: "Unexpected response from server.",
        disableSubmit: false,
        otpSent: false,      // ✅ Allow resending OTP on unexpected error
      });
    }

  } catch (error) {
    console.error('Error verifying OTP:', error);
    dispatch({
      error: "An unexpected error occurred. Please try again.",
      disableSubmit: false,
      otpSent: false,        // ✅ Allow resending OTP on network error
    });
  }
};



  // const onSignotp1 = async (data: { otp: string; emailId: string }) => {
  //   const otp = getValues('otp');
  //   const emailId = sessionStorage.getItem("NewEmail");

  //   if (!emailId) {
  //     dispatch({ error: "Email ID not found. Please try again." });
  //     return;
  //   }

  //   try {
  //     dispatch({ error: "", message: "", disableSubmit: true });

  //     const result = await changepasswordsumbit({ emailId, otp });

  //     if (result?.status === 'failed') {
  //       dispatch({
  //         error: result.message || "OTP verification failed. Please try again.",
  //         disableSubmit: false,
  //       });
  //     } else if (result?.status === 'success') {
  //       dispatch({
  //         message: result.message || "OTP verified successfully. Redirecting...",
  //         error: "",
  //         disableSubmit: false,
  //       });

  //       setTimeout(() => {
  //         window.location.href = "/portal/change-password";
  //       }, 1000);
  //     } else {
  //       dispatch({
  //         error: "Unexpected response from server.",
  //         disableSubmit: false,
  //       });
  //     }

  //   } catch (error) {
  //     console.error('Error verifying OTP:', error);
  //     dispatch({
  //       error: "An unexpected error occurred. Please try again.",
  //       disableSubmit: false,
  //     });
  //   }
  // };




  // const onSignotp1 = async (data: { otp: string; emailId: string }) => {
  //   dispatch({ error: "", message: "", disableSubmit: true });

  //   if (!data.otp) {
  //     dispatch({ error: "Please enter the OTP.", disableSubmit: false });
  //     return;
  //   }

  //   try {
  //     const response = await fetch(`${apiUrl}/forgotpassword/submit`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //       body: JSON.stringify({ emailId: emailNew, otp: data.otp }),
  //       credentials: "include",
  //     });

  //     const result = await response.json();

  //     if (!response.ok || !result.responseContent?.token) {
  //       throw new Error(result.message || "OTP verification failed.");
  //     }

  //     localStorage.setItem("authToken", result.responseContent.token);
  //     localStorage.setItem("userEmail", result.responseContent.emailId);

  //     dispatch({ message: "OTP verified successfully." });

  //     navigate("/change-password");
  //     window.location.href = "/change-password";
  //   } catch (err) {
  //     const errorMessage =
  //       err instanceof Error ? err.message : "An unexpected error occurred.";
  //     console.error("❌ Error verifying OTP:", errorMessage);
  //     dispatch({ error: errorMessage, disableSubmit: false });
  //   } finally {
  //     dispatch({ disableSubmit: false });
  //   }
  // };

  return (
    <div className="bg-white p-3 rounded-xl login-form w-100">
      <style>
        {`
          .otp-sent-text-color {
            color: rgb(2, 36, 10);
          }
        `}
      </style>
      {/* Email submission form */}
      <Form onSubmit={handleSubmit(handleEmailSubmit)}>
        <FormItem label="Username">
          <Input
            type="email"
            value={emailNew}
            placeholder="Enter Email Id"
            {...register("emailId")}
            readOnly={emailReadOnly}
          />
          {errors.emailId && (
            <p className="text-red-500">{errors.emailId.message}</p>
          )}
        </FormItem>
        <div className="mt-3 flex justify-end">
          <Button
            type="submit"
            disabled={isOtpSending || otpSent} // ✅ Disable after OTP is sent
            className="text-white hover:text-white bg-success"
          >
            {isOtpSending ? "Sending..." : "Send OTP"}
          </Button>
        </div>
      </Form>

      {/* OTP verification form */}
      {otpSent && (
        <Form onSubmit={handleSubmit(onSignotp1)} className="mt-4">
          <FormItem label="OTP">
            <Input
              type="text"
              placeholder="Enter OTP"
              {...register("otp", {
                required: "OTP is required",
                pattern: {
                  value: /^[0-9]+$/,
                  message: "Only digits are allowed",
                },
              })}
              maxLength={6} // Optional: Limit OTP length
              onKeyDown={(e) => {
                const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight']
                if (
                  !/[0-9]/.test(e.key) &&
                  !allowedKeys.includes(e.key)
                ) {
                  e.preventDefault()
                }
              }}
              onPaste={(e) => {
                const pasteData = e.clipboardData.getData('Text')
                if (!/^[0-9]+$/.test(pasteData)) {
                  e.preventDefault()
                }
              }}
            />
            {errors.otp && <p className="text-red-500">{errors.otp.message}</p>}
            {error && <p className="mt-2 text-left text-red-500">{error}</p>}
          </FormItem>

          <div className="mt-3 flex justify-end">
            <Button
              type="submit"
              className="text-white hover:text-white bg-success"
              disabled={disableSubmit}
            >
              {disableSubmit ? "Verifying..." : "Submit"}
            </Button>
          </div>
        </Form>
      )}

      {/* Display messages */}
      {error && <p className="mt-3 text-center text-red-500">{error}</p>}
      {message && <p className="mt-3 text-center otp-sent-text-color">{message}</p>}
    </div>
  );
};

export default ChangeOtpForm;
